import BaseUIMultiParcelView from 'xui/modules/order/BaseUIMultiParcelView'

export default class MultiParcelView extends BaseUIMultiParcelView {
  // static displayName = 'AddCoverSheetNote'
  static navigationOptions = {
    header: null,
  }
}
